import api from "./axios";

export const getCompanyConfig = async (id = 1) => {
  const response = await api.get("/company/" + id);
  return response.data;
};

export const updateCompanyConfig = async (company) => {
  const companyId = company.company_id;
  const body = {
    name: company.name,
    description: company.description,
    defontana_config: company.defontana_config,
    internal_config: company.internal_config,
  };
  const response = await api.put("/company/" + companyId, body);
  return response.data;
};
